import React, { useEffect, useState } from 'react';
import { ContainerForm } from '../../../components/Containers';
import Title from '../../../components/SincronizaNFe/TitleSincroniza';
import { useDispatch, useSelector } from 'react-redux';
import { MessageBoxAlert } from '../../../components/MessageBox';
import { SearchUserProjectAction } from '../../../redux/actions/project';
import CardProjectUser from '../../../components/SincronizaNFe/CardProjectUser';
import InputSearch from '../../../components/InputSearch';
import ButtonBack from '../../../components/ButtonBack';

export default function TemplateConsultResultProject({ userId }) {
  const [searchProject, setSearchProject] = useState('');
  const [nameUser, setNameUser] = useState('');
  const {
    searchUserProject,
    error: errorSearchUserProject,
    loading: loadingSearchProject,
  } = useSelector((state) => state.searchUserProject);
  const dispatch = useDispatch();

  const filteredProjects = searchProject
    ? searchUserProject.filter((project) => {
        return project.monthName.toLowerCase().includes(searchProject.toLowerCase());
      })
    : searchUserProject;

  useEffect(() => {
    if (!searchProject) {
      dispatch(SearchUserProjectAction(userId));
    }
  }, [dispatch, userId, searchProject]);

  useEffect(() => {
    if (errorSearchUserProject === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [errorSearchUserProject]);

  useEffect(() => {
    if (filteredProjects) {
      if (filteredProjects[0] === undefined) {
        setNameUser('Não há nenhum faturamentos para esse mês');
      } else {
        setNameUser(filteredProjects[0].user.name);
      }
    }
  }, [filteredProjects]);

  return (
    <ContainerForm>
      <Title text={nameUser} />
      <ButtonBack text="Voltar" path="/sincroniza-nfe/consultar-faturamentos" />
      {!errorSearchUserProject && (
        <InputSearch
          placeholder="Digite o nome do mês para encontrar o faturamento de deseja"
          state={searchProject}
          setState={setSearchProject}
        />
      )}
      {filteredProjects &&
        filteredProjects.map((project, index) => {
          return <CardProjectUser key={index + 1} project={project} />;
        })}
      {errorSearchUserProject && <MessageBoxAlert>{errorSearchUserProject}</MessageBoxAlert>}
      {loadingSearchProject && <MessageBoxAlert>Carregando...</MessageBoxAlert>}
    </ContainerForm>
  );
}
